import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("label", null, "Company", -1 /* HOISTED */);
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("label", null, "Action", -1 /* HOISTED */);
const _hoisted_3 = { class: "d-flex justify-content-between" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("label", null, "Users", -1 /* HOISTED */);
const _hoisted_5 = { class: "d-flex" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = ["disabled"];
const _hoisted_8 = {
    class: "list-filter",
    style: { "height": "300px", "overflow-x": "auto", "border": "1px solid black", "background-color": "whitesmoke" }
};
const _hoisted_9 = { class: "list-options" };
const _hoisted_10 = ["onClick"];
const _hoisted_11 = { style: { "font-weight": "700", "font-size": "16px" } };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_select = _resolveComponent("b-form-select");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createBlock(_component_b_modal, {
        class: "modal-form-lg",
        modelValue: _ctx.show,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.show) = $event)),
        title: _ctx.modalTitle,
        "header-bg-variant": "normal",
        size: "lg"
    }, {
        footer: _withCtx(() => [
            _createVNode(_component_b_button, {
                type: "button",
                variant: "secondary",
                onClick: _ctx.cancel
            }, {
                default: _withCtx(() => [
                    _createTextVNode("Cancel")
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"]),
            _createTextVNode(),
            _createVNode(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.submit,
                disabled: _ctx.selectedUserIds.length === 0
            }, {
                default: _withCtx(() => [
                    _createTextVNode("Submit")
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick", "disabled"])
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", null, [
                _hoisted_1,
                _createTextVNode(),
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedCompany,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompany) = $event)),
                    options: _ctx.companies,
                    "track-by": "value",
                    label: "text",
                    showLabels: false,
                    placeholder: "Select company",
                    class: "multiselect-small mb-3"
                }, {
                    noResult: _withCtx(() => [
                        _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t")
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
            ]),
            _createTextVNode(),
            _createElementVNode("div", null, [
                _hoisted_2,
                _createTextVNode(),
                _createVNode(_component_b_form_select, {
                    modelValue: _ctx.selectedAction,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedAction) = $event)),
                    options: _ctx.actionOptions,
                    class: "mb-3"
                }, null, 8 /* PROPS */, ["modelValue", "options"])
            ]),
            _createTextVNode(),
            _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("label", null, "Selected: " + _toDisplayString(_ctx.selectedUserIds.length), 1 /* TEXT */),
                        _createTextVNode(),
                        _withDirectives(_createElementVNode("input", {
                            class: "form-check-input ms-3",
                            style: { "margin-top": "2px" },
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.showOnlySelected) = $event)),
                            disabled: _ctx.selectedUserIds.length === 0
                        }, null, 8 /* PROPS */, _hoisted_6), [
                            [_vModelCheckbox, _ctx.showOnlySelected]
                        ]),
                        _createTextVNode(),
                        _createElementVNode("label", {
                            class: "form-check-label",
                            disabled: _ctx.selectedUserIds.length === 0
                        }, " Show only selected", 8 /* PROPS */, _hoisted_7)
                    ])
                ]),
                _createTextVNode(),
                _createVNode(_component_b_form_input, {
                    modelValue: _ctx.usersFilter,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.usersFilter) = $event)),
                    modelModifiers: { trim: true },
                    placeholder: "Search for..."
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsers, (user) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: user.userId,
                                class: _normalizeClass(['list-option', _ctx.isUserSelected(user) ? 'selected-option' : '']),
                                onClick: ($event) => (_ctx.toggleUser(user)),
                                style: { "text-align": "left", "padding": "5px" }
                            }, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("span", _hoisted_11, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("span", null, " - " + _toDisplayString(user.userName), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("span", null, " (" + _toDisplayString(user.emailAddress) + ")", 1 /* TEXT */)
                                ])
                            ], 10 /* CLASS, PROPS */, _hoisted_10));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ])
            ]),
            _createTextVNode()
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "title"]));
}
